module.exports = __webpack_public_path__ + "img/wallet-refresh-dots.eba62d14.svg";